import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=6b7289f3&scoped=true&"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementCard.vue?vue&type=style&index=0&id=6b7289f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7289f3",
  null
  
)

export default component.exports